module.exports = __webpack_public_path__ + "static/media/06C.ee03f0b0.png";